import { ThunkAction } from 'redux-thunk'
import axiosVerbose from '../../utils/axios/axiosVerbose'

import { logError, ResponseDataError } from '../../utils/errors'

import { IRootState } from '../../reducers'
import {
  IGetRecommendedSearchesByTermResultsFailAction,
  IGetRecommendedSearchesByTermResultsRequestAction,
  IGetRecommendedSearchesByTermResultsSuccessAction,
  TypeKeys
} from '../searchPage'

const fetchRecommendedSearchesByTermResults = (
  term: string,
  { apiUrlPrefix }: { apiUrlPrefix: string }
): ThunkAction<
  Promise<
    | IGetRecommendedSearchesByTermResultsRequestAction
    | IGetRecommendedSearchesByTermResultsSuccessAction
    | IGetRecommendedSearchesByTermResultsFailAction
  >,
  IRootState,
  void
> => {
  return dispatch => {
    const url = `${apiUrlPrefix}/shopfront_api/recommendation/${encodeURIComponent(
      term
    )}`
    const requestAction: IGetRecommendedSearchesByTermResultsRequestAction = {
      type: TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_REQUEST
    }
    dispatch(requestAction)

    return axiosVerbose
      .get(url, { timeout: 5000 })
      .then(res => {
        if (res.data && res.data.relatedSearches) {
          const successAction: IGetRecommendedSearchesByTermResultsSuccessAction = {
            type: TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_SUCCESS,
            payload: {
              recommendations: res.data.relatedSearches,
              hint: term,
              type: 'term'
            }
          }
          return dispatch(successAction)
        } else {
          throw ResponseDataError({ response: res })
        }
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(err => {
        return dispatch(fetchRecommendedSearchesByTermResultsFailure())
      })
  }
}

const fetchRecommendedSearchesByTermResultsFailure = (): ThunkAction<
  IGetRecommendedSearchesByTermResultsFailAction,
  IRootState,
  void
> => {
  return dispatch => {
    const action: IGetRecommendedSearchesByTermResultsFailAction = {
      type: TypeKeys.GET_RECOMMENDED_SEARCHES_BY_TERM_RESULTS_FAIL,
      error: true
    }
    return dispatch(action)
  }
}

export default fetchRecommendedSearchesByTermResults
